import React, { useState, useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Loader from "../../components/Loader";
import useAprobarPartidasStore from "../../store/aprobarPartidasStore";
import { toast } from "react-toastify";

const AprobarPartidasPage = () => {
  const { isLoading, error, partidas, iniciar, aprobarPartida, cancelarPartida } = useAprobarPartidasStore();
  const [aprobandose, setAprobandose] = useState(null);
  const [cancelandose, setCancelandose] = useState(null);

  useEffect(() => {
    iniciar();
  }, [iniciar]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("es-MX", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  const formatTime = (timeString) => {
    if (!timeString) return "";
    const match = timeString.match(/(\d{1,2}):(\d{2}):(\d{2})/);
    if (match) {
      return `${match[1].padStart(2, "0")}:${match[2]}`;
    }
    return timeString;
  };

  const handleAprobar = async (id) => {
    setAprobandose(id);
    const result = await aprobarPartida(id);
    setAprobandose(null);
    if (result.success) {
      toast.success(result.message || "Partida aprobada correctamente");
    } else {
      toast.error(result.message || "Error al aprobar la partida");
    }
  };

  const handleCancelar = async (id) => {
    if (!window.confirm("¿Cancelar esta partida? El horario volverá a estar disponible.")) return;

    setCancelandose(id);
    const result = await cancelarPartida(id);
    setCancelandose(null);
    if (result.success) {
      toast.success(result.message || "Partida cancelada y horario liberado");
    } else {
      toast.error(result.message || "Error al cancelar la partida");
    }
  };

  return (
    <MasterLayout>
      <div className="card">
        <div className="card-header">
          <h4 className="mb-0">Aprobar Partidas</h4>
          <p className="text-muted mb-0">Partidas pendientes por aprobar</p>
        </div>
        <div className="card-body">
          {error && (
            <div className="alert alert-warning" role="alert">
              {error}
            </div>
          )}
          {isLoading ? (
            <Loader />
          ) : partidas.length === 0 ? (
            <div className="text-center py-5">
              <i className="ri-checkbox-circle-line" style={{ fontSize: "48px", color: "#6c757d" }}></i>
              <p className="mt-3 text-muted">No hay partidas pendientes por aprobar</p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Fecha</th>
                    <th>Hora</th>
                    <th>Cancha</th>
                    <th>Sucursal</th>
                    <th>Cliente</th>
                    <th>Correo</th>
                    <th>Teléfono</th>
                    <th>Nivel</th>
                    <th>Categoría</th>
                    <th>Jugadores</th>
                    <th>Comentarios</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {partidas.map((partida) => (
                    <tr key={partida.ID_MAT}>
                      <td>{partida.ID_MAT}</td>
                      <td>{formatDate(partida.DIA_MAT)}</td>
                      <td>{formatTime(partida.INICIO_HORA)} - {formatTime(partida.FIN_HORA)}</td>
                      <td>{partida.NOMBRE_CAN} #{partida.NUMERO_CANCHA_CAN}</td>
                      <td>{partida.NOMBRE_SUCURSAL_SUC}</td>
                      <td>{partida.NOMBRE_COMPLETO}</td>
                      <td>{partida.CORREO_DP}</td>
                      <td>{partida.TELEFONO_DP}</td>
                      <td>{partida.NIVEL_MAT || "No especificado"}</td>
                      <td>{partida.CATEGORIA_MAT || "No especificada"}</td>
                      <td>{partida.CURRENT_PLAYERS_MAT || 0}/{partida.MAX_PLAYERS_MAT}</td>
                      <td style={{ maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {partida.COMENTARIOS_MAT || "Sin comentarios"}
                      </td>
                      <td>
                        <div className="d-flex flex-wrap gap-2">
                        <button
                          className="btn btn-success btn-sm"
                          onClick={() => handleAprobar(partida.ID_MAT)}
                          disabled={aprobandose === partida.ID_MAT || cancelandose === partida.ID_MAT}
                        >
                          {aprobandose === partida.ID_MAT ? (
                            <span className="spinner-border spinner-border-sm"></span>
                          ) : (
                            <>
                              <i className="ri-check-line me-1"></i>
                              Aprobar
                            </>
                          )}
                        </button>
                        <button
                          className="btn btn-outline-danger btn-sm"
                          onClick={() => handleCancelar(partida.ID_MAT)}
                          disabled={aprobandose === partida.ID_MAT || cancelandose === partida.ID_MAT}
                        >
                          {cancelandose === partida.ID_MAT ? (
                            <span className="spinner-border spinner-border-sm"></span>
                          ) : (
                            <>
                              <i className="ri-close-line me-1"></i>
                              Cancelar
                            </>
                          )}
                        </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </MasterLayout>
  );
};

export default AprobarPartidasPage;
